import Vue from 'vue'
import Store from 'store'

import AddedToCartNotification from './AddedToCartNotification.vue'

const el = '.nti-component--cart-notification'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){

        const dataShoppingUrl = DOM.dataset.datashoppingurl
        const continueShoppingLabel = DOM.dataset.continueshoppinglabel
        const toBasketLabel = DOM.dataset.tobasketlabel
        const toBasketUrl = DOM.dataset.tobasketurl
        
        new Vue({
            store: Store,
            el,
            components:{
                AddedToCartNotification
            },
            template: `<AddedToCartNotification dataShoppingUrl='${dataShoppingUrl}' continueShoppingLabel='${continueShoppingLabel}' toBasketLabel='${toBasketLabel}' toBasketUrl='${toBasketUrl}' />`
        })
    }
}

export default {
    render
}